import { logger } from '../lib/utils/logger'
import { handleActions } from 'redux-actions'
import {
  clipboardEnable,
  clipboardDisable,
  clipboardPaste,
  clipboardPasteFail,
  clipboardRemoteReceive,
  clipboardRemoteReceiveSyncDone,
  clipboardRemoteReceiveSyncFail,
} from './../actions/clipboard'
import { CLIPBOARD_SYNC_STATUS } from '../lib/clipboard'
import {
  FEATURE_CLIPBOARD_SYNCHRONIZATION,
} from '../api/env'
import {
  showClipboardButton
} from '../lib/utils/browser'

const initialState = {
  enabled: FEATURE_CLIPBOARD_SYNCHRONIZATION,
  remoteText: '',
  remoteTextSyncStatus: CLIPBOARD_SYNC_STATUS.NONE,
  showClipboardButton,
}

export const clipboardReducer = handleActions({
  [clipboardEnable] (prevState) {
    logger('clipboardEnable')
    return {
      ...prevState,
      ...initialState,
    }
  },
  [clipboardDisable] (prevState) {
    logger('clipboardDisable')
    return {
      ...prevState,
      ...initialState,
      enabled: false,
    }
  },
  [clipboardPaste] (prevState /* , action*/) {
    logger('clipboardPaste')
    return {
      ...prevState,
    }
  },
  [clipboardPasteFail] (prevState, action) {
    logger('clipboardPasteFail', action.payload)
    return {
      ...prevState
    }
  },
  [clipboardRemoteReceive] (prevState, action) {
    logger('clipboardRemoteReceive', action.payload)
    return {
      ...prevState,
      remoteTextSyncStatus: CLIPBOARD_SYNC_STATUS.PENDING,
      remoteText: action.payload.text,
    }
  },
  [clipboardRemoteReceiveSyncDone] (prevState) {
    logger('clipboardRemoteReceiveSyncDone')
    return {
      ...prevState,
      remoteTextSyncStatus: CLIPBOARD_SYNC_STATUS.DONE,
    }
  },
  [clipboardRemoteReceiveSyncFail] (prevState) {
    logger('clipboardRemoteReceiveSyncFail')
    return {
      ...prevState,
      remoteTextSyncStatus: CLIPBOARD_SYNC_STATUS.FAIL,
    }
  }
}, initialState)
